export default {
  "Login for users": "Аккаунтқа кіру",
  Login: "Электрондық пошта / телефон",
  Password: "Құпиясөз",
  Submit: "Кіру",
  "Field required": "Бұл өріс міндетті",
  "Auth error 400": "Қате логин немесе құпиясөз",
  "Auth error network":
    "Қосылу мәселесі. Интернет байланысыңызды тексеріп, қайталап көріңіз.",
  "Auth error unknown": "Қате орын алды. Кейінірек қайталап көріңіз.",
  "Login title": "Авторизация | " + process.env.VUE_APP_INSTALL_NAME + "",
  "Not account yet": "Аккаунтыңыз жоқ па?",
  "Not account yet about":
    "Сіз аккаунт жасай аласыз немесе шектеулі функциялармен демо режиміне кіре аласыз",
  "Demo-mode": "Демо режим",
  "Let register": "Тіркелу",
  "User Agreement Title":
    "Пайдаланушы келісімі | " + process.env.VUE_APP_INSTALL_NAME + "",
  "User Agreement": "Пайдаланушы келісімі",
  "Privacy policy": "Жеке деректерді өңдеу саясаты",
  "User Agreement About part 1":
    "Сайтты пайдалана отырып, сіз келесілермен келісесіз ",
  "User Agreement About part 2": "пайдаланушы келісімі.",
  "User Agree": "Қабылдаймын",
  "Page not found": "Бет табылмады",
  "Page not found about":
    "Мекенжай қате терілген немесе бұл бет жойылған. Басты бетке оралыңыз",
  "Back to main page": "Басты бетке оралу",
  "Login for users 2":
    "Платформаның барлық функцияларына толық қол жеткізу үшін кіріңіз " +
    process.env.VUE_APP_INSTALL_NAME +
    "",
  Step: "Қадам",
  "Min 8": "Кемінде 8 таңба",
  "1 char": "1 әріп",
  "1 num": "1 сан",
  "Auth access 1": "Келісемін ",
  "Auth access 2": "жеке деректерді өңдеуге",
  "Auth access 3": ", келесі шарттарды қабылдаймын ",
  "Auth access 4": "саясат",
  "Auth access 5": "және",
  "Auth access 6": "пайдаланушы келісімі",
  "Have account?": "Аккаунтыңыз бар ма?",
  "To next": "Келесі",
  "Reg for users 1": "Аккаунт жасаңыз",
  "Reg for users 2": "Өзіңіз туралы айтып беріңіз",
  "Reg for users 3": "Тіркеуді аяқтау",
  "Your last_name": "Тегіңіз",
  "Your first_name": "Атыңыз",
  "Your middle_name": "Әкеңіздің аты",
  "Your company": "Жұмыс орны",
  "Your position_in_the_company": "Мамандығыңыз",
  Back: "Артқа",
  "Min 2": "Кемінде 2 таңба",
  Promo: "Промокод (бар болса)",
  invitation_1: "Таныстардан / әріптестерден",
  invitation_2: "Email таралымы",
  invitation_3: "Яндекс, Google іздеу жүйелерінен",
  invitation_4: "Басқа дереккөз",
  invitation_5: "Әлеуметтік желілер",
  "Where know about platform?": "Платформа туралы қайдан білдіңіз?",
  "Reg finish": "Тіркелу",
  regErrorText: "Қолданушыны тіркеу мүмкін болмады. Мәліметтерді тексеріңіз",
  "Auth banner text":
    "Платформаның барлық функцияларына қол жеткізу үшін жүйеге кіріңіз",
  "Auth banner text 2":
    "Өңдеуге болатын зерттеулер санын арттыру үшін жүйеге кіріңіз",
  "Auth banner text 3": "10 зерттеуіңізді тегін өңдеңіз",
  "Reg error":
    "Техникалық ақауға байланысты тіркеуді аяқтау мүмкін болмады. Кейінірек қайталап көріңіз",
  "Reg error 400": "Бұл электрондық пошта мекенжайы бұрыннан қолданылған",
  "Rem password": "Тіркеу кезінде көрсеткен электрондық поштаңызды енгізіңіз",
  Phone: "Телефон",
  "Not valid phone": "Телефон нөмірінің форматы қате",
  emailVerify: {
    title: "Эл. поштаны растау",
    desc1: "Келесі мекенжайға хат жіберілді: ",
    desc2: ". Аккаунтыңызды белсендіру үшін хаттағы сілтеме арқылы өтіңіз.",
  },
};
